import React from 'react';
import { ROUTE_THINK, ROUTE_MAIN_PAGE } from 'constants/urls';
import history from 'store/history';
import {
  BtnSubmit, CongratulationsSubtitle, CongratulationsTitle, CongratulationsWrapper,
} from './styles';
import initialize from './animation';

class Congratulations extends React.Component {
  componentDidMount() {
    initialize();
  }

  handleClick = () => {
    const { setGoDown } = this.props;
    if (window.location.pathname === ROUTE_MAIN_PAGE) {
      setGoDown(true);
    } else {
      history.push(ROUTE_THINK);
    }
  }

  render() {
    const {
      literals, darkerColor,
    } = this.props;
    return (

      <CongratulationsWrapper>
        <canvas className='confetti' />
        <CongratulationsTitle>
          {literals.congratulations}
        </CongratulationsTitle>
        <CongratulationsSubtitle>
          {literals.thinkChatCreated}
        </CongratulationsSubtitle>
        {darkerColor ? (
          <BtnSubmit
            type='button'
            color={darkerColor}
            darkerColor={darkerColor}
            onClick={this.handleClick}
            style={{ zIndex: '50' }}
          >
            {literals.continue}
          </BtnSubmit>
        ) : null}
      </CongratulationsWrapper>
    );
  }
}
export default Congratulations;



// WEBPACK FOOTER //
// ./src/components/CreationThinkSeed/components/Congratulations.jsx